export default {
  colorDataSet: [
    {
      colorType: 'blue',
      hexCode: '#F0F8FF',
      name: 'AliceBlue',
      viewColor: 'black'
    },
    {
      colorType: 'gray',
      hexCode: '#FAEBD7',
      name: 'AntiqueWhite',
      viewColor: 'black'
    },
    {
      hexCode: '#00FFFF',
      name: 'Aqua',
      viewColor: 'white'
    },
    {
      hexCode: '#7FFFD4',
      name: 'Aquamarine',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#F0FFFF',
      name: 'Azure',
      viewColor: 'black'
    },
    {
      colorType: 'gray',
      hexCode: '#F5F5DC',
      name: 'Beige',
      viewColor: 'black'
    },
    {
      colorType: 'brown',
      hexCode: '#FFE4C4',
      name: 'Bisque',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#000000',
      name: 'Black',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#FFEBCD',
      name: 'BlanchedAlmond',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#0000FF',
      name: 'Blue',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#8A2BE2',
      name: 'BlueViolet',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#A52A2A',
      name: 'Brown',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#DEB887',
      name: 'BurlyWood',
      viewColor: 'white'
    },
    {
      colorType: 'cyan',
      hexCode: '#5F9EA0',
      name: 'CadetBlue',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#7FFF00',
      name: 'Chartreuse',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#D2691E',
      name: 'Chocolate',
      viewColor: 'white'
    },
    {
      colorType: 'orange',
      hexCode: '#FF7F50',
      name: 'Coral',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#6495ED',
      name: 'CornflowerBlue',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#FFF8DC',
      name: 'Cornsilk',
      viewColor: 'black'
    },
    {
      colorType: 'red',
      hexCode: '#DC143C',
      name: 'Crimson',
      viewColor: 'white'
    },
    {
      colorType: 'cyan',
      hexCode: '#00FFFF',
      name: 'Cyan',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#00008B',
      name: 'DarkBlue',
      viewColor: 'white'
    },
    {
      colorType: 'cyan',
      hexCode: '#008B8B',
      name: 'DarkCyan',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#B8860B',
      name: 'DarkGoldenRod',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#A9A9A9',
      name: 'DarkGray',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#A9A9A9',
      name: 'DarkGrey',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#006400',
      name: 'DarkGreen',
      viewColor: 'white'
    },
    {
      colorType: 'yellow',
      hexCode: '#BDB76B',
      name: 'DarkKhaki',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#8B008B',
      name: 'DarkMagenta',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#556B2F',
      name: 'DarkOliveGreen',
      viewColor: 'white'
    },
    {
      colorType: 'orange',
      hexCode: '#FF8C00',
      name: 'DarkOrange',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#9932CC',
      name: 'DarkOrchid',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#8B0000',
      name: 'DarkRed',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#E9967A',
      name: 'DarkSalmon',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#8FBC8F',
      name: 'DarkSeaGreen',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#483D8B',
      name: 'DarkSlateBlue',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#2F4F4F',
      name: 'DarkSlateGray',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#2F4F4F',
      name: 'DarkSlateGrey',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#00CED1',
      name: 'DarkTurquoise',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#9400D3',
      name: 'DarkViolet',
      viewColor: 'white'
    },
    {
      colorType: 'pink',
      hexCode: '#FF1493',
      name: 'DeepPink',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#00BFFF',
      name: 'DeepSkyBlue',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#696969',
      name: 'DimGray',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#696969',
      name: 'DimGrey',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#1E90FF',
      name: 'DodgerBlue',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#B22222',
      name: 'FireBrick',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#FFFAF0',
      name: 'FloralWhite',
      viewColor: 'black'
    },
    {
      colorType: 'green',
      hexCode: '#228B22',
      name: 'ForestGreen',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#FF00FF',
      name: 'Fuchsia',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#DCDCDC',
      name: 'Gainsboro',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#F8F8FF',
      name: 'GhostWhite',
      viewColor: 'black'
    },
    {
      colorType: 'orange',
      hexCode: '#FFD700',
      name: 'Gold',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#DAA520',
      name: 'GoldenRod',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#808080',
      name: 'Gray',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#808080',
      name: 'Grey',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#008000',
      name: 'Green',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#ADFF2F',
      name: 'GreenYellow',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#F0FFF0',
      name: 'HoneyDew',
      viewColor: 'black'
    },
    {
      colorType: 'pink',
      hexCode: '#FF69B4',
      name: 'HotPink',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#CD5C5C',
      name: 'IndianRed',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#4B0082',
      name: 'Indigo',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#FFFFF0',
      name: 'Ivory',
      viewColor: 'black'
    },
    {
      colorType: 'yellow',
      hexCode: '#F0E68C',
      name: 'Khaki',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#E6E6FA',
      name: 'Lavender',
      viewColor: 'black'
    },
    {
      colorType: 'gray',
      hexCode: '#FFF0F5',
      name: 'LavenderBlush',
      viewColor: 'black'
    },
    {
      colorType: 'green',
      hexCode: '#7CFC00',
      name: 'LawnGreen',
      viewColor: 'white'
    },
    {
      colorType: 'yellow',
      hexCode: '#FFFACD',
      name: 'LemonChiffon',
      viewColor: 'black'
    },
    {
      colorType: 'blue',
      hexCode: '#ADD8E6',
      name: 'LightBlue',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#F08080',
      name: 'LightCoral',
      viewColor: 'white'
    },
    {
      colorType: 'cyan',
      hexCode: '#E0FFFF',
      name: 'LightCyan',
      viewColor: 'black'
    },
    {
      colorType: 'yellow',
      hexCode: '#FAFAD2',
      name: 'LightGoldenRodYellow',
      viewColor: 'black'
    },
    {
      colorType: 'gray',
      hexCode: '#D3D3D3',
      name: 'LightGray',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#D3D3D3',
      name: 'LightGrey',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#90EE90',
      name: 'LightGreen',
      viewColor: 'white'
    },
    {
      colorType: 'pink',
      hexCode: '#FFB6C1',
      name: 'LightPink',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#FFA07A',
      name: 'LightSalmon',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#20B2AA',
      name: 'LightSeaGreen',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#87CEFA',
      name: 'LightSkyBlue',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#778899',
      name: 'LightSlateGray',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#778899',
      name: 'LightSlateGrey',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#B0C4DE',
      name: 'LightSteelBlue',
      viewColor: 'white'
    },
    {
      colorType: 'yellow',
      hexCode: '#FFFFE0',
      name: 'LightYellow',
      viewColor: 'black'
    },
    {
      colorType: 'green',
      hexCode: '#00FF00',
      name: 'Lime',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#32CD32',
      name: 'LimeGreen',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#FAF0E6',
      name: 'Linen',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#FF00FF',
      name: 'Magenta',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#800000',
      name: 'Maroon',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#66CDAA',
      name: 'MediumAquaMarine',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#0000CD',
      name: 'MediumBlue',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#BA55D3',
      name: 'MediumOrchid',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#9370DB',
      name: 'MediumPurple',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#3CB371',
      name: 'MediumSeaGreen',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#7B68EE',
      name: 'MediumSlateBlue',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#00FA9A',
      name: 'MediumSpringGreen',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#48D1CC',
      name: 'MediumTurquoise',
      viewColor: 'white'
    },
    {
      colorType: 'pink',
      hexCode: '#C71585',
      name: 'MediumVioletRed',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#191970',
      name: 'MidnightBlue',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#F5FFFA',
      name: 'MintCream',
      viewColor: 'black'
    },
    {
      colorType: 'gray',
      hexCode: '#FFE4E1',
      name: 'MistyRose',
      viewColor: 'black'
    },
    {
      colorType: 'yellow',
      hexCode: '#FFE4B5',
      name: 'Moccasin',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#FFDEAD',
      name: 'NavajoWhite',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#000080',
      name: 'Navy',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#FDF5E6',
      name: 'OldLace',
      viewColor: 'black'
    },
    {
      colorType: 'green',
      hexCode: '#808000',
      name: 'Olive',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#6B8E23',
      name: 'OliveDrab',
      viewColor: 'white'
    },
    {
      colorType: 'orange',
      hexCode: '#FFA500',
      name: 'Orange',
      viewColor: 'white'
    },
    {
      colorType: 'orange',
      hexCode: '#FF4500',
      name: 'OrangeRed',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#DA70D6',
      name: 'Orchid',
      viewColor: 'white'
    },
    {
      colorType: 'yellow',
      hexCode: '#EEE8AA',
      name: 'PaleGoldenRod',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#98FB98',
      name: 'PaleGreen',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#AFEEEE',
      name: 'PaleTurquoise',
      viewColor: 'white'
    },
    {
      colorType: 'pink',
      hexCode: '#DB7093',
      name: 'PaleVioletRed',
      viewColor: 'white'
    },
    {
      colorType: 'yellow',
      hexCode: '#FFEFD5',
      name: 'PapayaWhip',
      viewColor: 'white'
    },
    {
      colorType: 'yellow',
      hexCode: '#FFDAB9',
      name: 'PeachPuff',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#CD853F',
      name: 'Peru',
      viewColor: 'white'
    },
    {
      colorType: 'pink',
      hexCode: '#FFC0CB',
      name: 'Pink',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#DDA0DD',
      name: 'Plum',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#B0E0E6',
      name: 'PowderBlue',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#800080',
      name: 'Purple',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#663399',
      name: 'RebeccaPurple',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#FF0000',
      name: 'Red',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#BC8F8F',
      name: 'RosyBrown',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#4169E1',
      name: 'RoyalBlue',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#8B4513',
      name: 'SaddleBrown',
      viewColor: 'white'
    },
    {
      colorType: 'red',
      hexCode: '#FA8072',
      name: 'Salmon',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#F4A460',
      name: 'SandyBrown',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#2E8B57',
      name: 'SeaGreen',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#FFF5EE',
      name: 'SeaShell',
      viewColor: 'black'
    },
    {
      colorType: 'brown',
      hexCode: '#A0522D',
      name: 'Sienna',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#C0C0C0',
      name: 'Silver',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#87CEEB',
      name: 'SkyBlue',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#6A5ACD',
      name: 'SlateBlue',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#708090',
      name: 'SlateGray',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#708090',
      name: 'SlateGrey',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#FFFAFA',
      name: 'Snow',
      viewColor: 'black'
    },
    {
      colorType: 'green',
      hexCode: '#00FF7F',
      name: 'SpringGreen',
      viewColor: 'white'
    },
    {
      colorType: 'blue',
      hexCode: '#4682B4',
      name: 'SteelBlue',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#D2B48C',
      name: 'Tan',
      viewColor: 'white'
    },
    {
      colorType: 'cyan',
      hexCode: '#008080',
      name: 'Teal',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#D8BFD8',
      name: 'Thistle',
      viewColor: 'white'
    },
    {
      colorType: 'orange',
      hexCode: '#FF6347',
      name: 'Tomato',
      viewColor: 'white'
    },
    {
      colorType: 'green',
      hexCode: '#40E0D0',
      name: 'Turquoise',
      viewColor: 'white'
    },
    {
      colorType: 'purple',
      hexCode: '#EE82EE',
      name: 'Violet',
      viewColor: 'white'
    },
    {
      colorType: 'brown',
      hexCode: '#F5DEB3',
      name: 'Wheat',
      viewColor: 'white'
    },
    {
      colorType: 'gray',
      hexCode: '#FFFFFF',
      name: 'White',
      viewColor: 'black'
    },
    {
      colorType: 'gray',
      hexCode: '#F5F5F5',
      name: 'WhiteSmoke',
      viewColor: 'black'
    },
    {
      colorType: 'yellow',
      hexCode: '#FFFF00',
      name: 'Yellow',
      viewColor: 'black'
    },
    {
      colorType: 'green',
      hexCode: '#9ACD32',
      name: 'YellowGreen',
      viewColor: 'white'
    }
  ],
  filters: [
    {
      name: 'All',
      filterBy: ''
    },
    {
      name: 'Pink',
      filterBy: 'pink'
    },
    {
      name: 'Red',
      filterBy: 'red'
    },
    {
      name: 'Orange',
      filterBy: 'orange'
    },
    {
      name: 'Yellow',
      filterBy: 'yellow'
    },
    {
      name: 'Brown',
      filterBy: 'brown'
    },
    {
      name: 'Green',
      filterBy: 'green'
    },
    {
      name: 'Cyan',
      filterBy: 'cyan'
    },
    {
      name: 'Blue',
      filterBy: 'blue'
    },
    {
      name: 'Purple',
      filterBy: 'purple'
    },
    {
      name: 'Gray',
      filterBy: 'gray'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/api/data.ts